// extracted by mini-css-extract-plugin
module.exports = {"input-group":"InputMobile_input-group__2_i0Q","select":"InputMobile_select__8Z_j7","select-option":"InputMobile_select-option__1mC20"};